{
  "dailyChecklist": {
    "title": "Missões Diárias",
    "subtitle": "Comunidade Circle",
    "bonusTitle": "Trifecta Diária",
    "bonusDescription": "Complete as 3 para bônus extra",
    "tasks": {
      "post": {
        "title": "Criar um post",
        "description": "Publique um post na comunidade"
      },
      "comment": {
        "title": "Fazer um comentário",
        "description": "Comente em um post da comunidade"
      },
      "like": {
        "title": "Curtir um post",
        "description": "Curta um post ou comentário na comunidade"
      }
    }
  },
  "toasts": {
    "xpEarned": "+{{xp}} XP conquistado!",
    "xpEarnedDescription": "Continue assim para subir de nível!",
    "streakMilestone_one": "🔥 {{count}} dia consecutivo!",
    "streakMilestone_zero": "🔥 {{count}} dias consecutivos!",
    "streakMilestone_other": "🔥 {{count}} dias consecutivos!",
    "streakMilestoneDescription": "Sua dedicação é inspiradora!",
    "streakUpdated": "Sequência atualizada!",
    "consecutiveDays_one": "{{count}} dia consecutivo",
    "consecutiveDays_zero": "{{count}} dias consecutivos",
    "consecutiveDays_other": "{{count}} dias consecutivos"
  }
}
